import { Box} from '@mui/material'
import { useEffect } from 'react'
import { Page_Padding } from '../shared/constants'
import { usePageContentWithMeta } from '../shared/hook/usePageContentWithMeta'
const PricingPolicy = ({ onLoadingChange }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("PRICING_POLICY");
    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);

    if (isLoading) return null;
    return (
        // <Box sx={{ padding:Page_Padding}}>
        //     <Typography variant='h1'>Pricing Policy</Typography>
        //     <CustomDivider size={20} />
        //     <List component={"ul"} sx={{ listStyleType: 'disc', pl: 2 }}>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 At MySkill Club(hereinafter referred as we/our), We
        //                 are committed to providing clear and transparent
        //                 pricing for all products and services offered on our
        //                 website. This policy outlines how we determine our
        //                 prices, what payment methods we accept, and how we
        //                 handle potential price changes.
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 All prices displayed on our website are in rupees and
        //                 include any applicable taxes.
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We strive to ensure that all prices displayed on our
        //                     website are accurate and up-to-date. However, we
        //                     reserve the right to correct any errors or inaccuracies
        //                     in pricing.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We do not charge any hidden fees or surcharges. The
        //                     price you see is the price you pay, unless otherwise
        //                     stated.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We accept the following payment methods: [credit
        //                     cards and debit cards (Visa, Mastercard, American
        //                     Express),UPI, GPay, Razorpay,  etc.]
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We use secure payment processing to ensure the
        //                     safety and security of your financial information.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We reserve the right to change prices at any time
        //                     without prior notice. However, we will make
        //                     reasonable efforts to inform customers of any
        //                     significant price changes.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     We may offer promotional discounts or special offers
        //                     from time to time. These offers are subject to specific
        //                     terms and conditions, which will be clearly stated at
        //                     the time of the offer.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //     </List>
        //     <CustomDivider size={20} />
        //     <Typography variant='h5' fontWeight={"bold"}>Contact Us:support@myskill.club</Typography>
        //     <CustomDivider size={20} />
        //     <Typography variant='body2'>
        //         If you have any questions about our pricing policy,
        //         please contact us at info@myskill.com</Typography>


        // </Box>
        <Box sx={{ padding: Page_Padding }}>
            <div dangerouslySetInnerHTML={{ __html: Detail?.content?.[0]?.data?.detail }} />
        </Box>
    )
}

export default PricingPolicy